import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import preview from './orderVolumeProfilePreview.png';
import { OrderVolumeProfileHelpText } from 'widgets/orderVolumeProfile/components/help/OrderVolumeProfileHelp.tsx';

export const orderVolumeProfileDescription: DropdownTooltipText = {
    body: <OrderVolumeProfileHelpText />,
    previews: [{ src: preview, altText: 'vorder-volume-profile-preview' }],
};
